var commonProductsData = [];
let isModifyTriggered = false;
let activeGenderIndex = null;
// State storage for current heading text per pair
const pairStyleTexts = ["", ""]; // store selected styles per pair
const pairSizeTexts = ["", ""];  // store selected sizes per pair

  document.addEventListener("DOMContentLoaded", function () {
    function setStepParam(param) {
    const url = new URL(window.location.href);
    url.searchParams.set("step", param);
    let stepMainClasses = document.querySelector(".matching-undes-main")?.classList;
    stepMainClasses?.remove("step-i-wear");
    stepMainClasses?.remove("step-partner-wear");
    stepMainClasses?.add(`step-${param}`);
    window.history.replaceState({}, "", url);
  }

  setStepParam("i-wear");
  
    const genderTabs = document.querySelectorAll(".gender-tab");
    const collections = document.querySelectorAll(".collection-items");
    const imageBoxes = document.querySelectorAll(".matching-undies__images .image-box");

    let currentBoxIndex = 0;

    // Track completion per box
    const selections = [
      { style: false, size: false, styleName: null, sizeValue: null },
      { style: false, size: false, styleName: null, sizeValue: null }
    ];

    // -------------------- Step 3 HTML --------------------
    function generateHtmlForStep3() {
  const container = document.querySelector(".preview-variant-inner");
  if (!container) return;

  container.innerHTML = "";
  const commonProducts = JSON.parse(localStorage.getItem("commonProductsformatching") || "[]");

  // Group by design_name
  const grouped = {};
  commonProducts.forEach(p => {
    if (!grouped[p.design_name]) grouped[p.design_name] = [];
    grouped[p.design_name].push(p);
  });

  Object.values(grouped).forEach(group => {
    const design = group[0].design_name;
    const shapeStyle = group[0].shape_style;
    const productIds = group.map(p => p.product_id).join(",");

    // ✅ Check preview image availability (but don’t replace swatch icon!)
    const previewImg = getProductPreviewImage(group[0].product_id);
    const isValid = previewImg && !previewImg.includes("No+Image");

    const div = document.createElement("div");
    div.className = "type_swatch all";

    div.innerHTML = `
      <button class="tab-swatch"
              data-name="${design}"
              data-type="${shapeStyle}"
              data-product-ids="${productIds}"
              ${!isValid ? "disabled" : ""}>
        <img src="${group[0].swatch_icon}" alt="${design}" 
             style="${!isValid ? "opacity:0.5;cursor:not-allowed;" : ""}">
      </button>
    `;

    container.appendChild(div);
  });
}


    // -------------------- Completion Check --------------------
    function checkCompletion() {
  const step3 = document.querySelector(".step-3-wrapper");
  const stepGuideText = document.querySelector(".step-guide-text");
  const nextStemBtnMain = document.querySelector(".pointer-visible");

  if (selections.every(sel => sel.style && sel.size)) {
    setCommonProducts();
    if (step3) {
      step3.classList.add("active");
      document.querySelector(".step-3-instruction").style.display = "none";
    }
    generateHtmlForStep3();
    setupTabSwatchClickHandlers();
    if (stepGuideText) stepGuideText.style.display = "none";
    // if (nextStemBtnMain) {
    //   nextStemBtnMain.style.pointerEvents = "auto";
    // }
  } else {
    if (step3) {
      step3.classList.remove("active");
      document.querySelector(".step-3-instruction").style.display = "block";
    }
    if (stepGuideText) stepGuideText.style.display = "block";
    if (nextStemBtnMain) {
      nextStemBtnMain.style.pointerEvents = "none";
    }
  }

  // ✅ NEW LINE ADDED HERE
  if (document.querySelector(".tab-swatch.active") && nextStemBtnMain) {
    nextStemBtnMain.style.pointerEvents = "auto";
  }

  const gender1Done = localStorage.getItem("matching-undies-gender-for1");
  const firstGenderSelection = selections[0]; // first gender object

  if (gender1Done && firstGenderSelection.style && firstGenderSelection.size) {
    setStepParam("partner-wear");
  }
}

    // -------------------- Gender Tab Toggle --------------------
 
genderTabs.forEach((tab, index) => {
tab.setAttribute("btn-index", index);
  tab.addEventListener("click", () => {
    activeGenderIndex = index; // 👈 remember which gender is active
    resetStepHeadings(index);
    console.warn("Clicked gender tab index:", tab.getAttribute("btn-index")); 
    snfWidgetCode();
    const commonClasses = document.querySelectorAll('.commonclass');
    console.warn('common classes need to be removed length:', commonClasses.length);
    commonClasses.forEach(commonClass => {
      console.warn('common class being removed:', commonClass);

      if (commonClass.classList.contains('change-text')) {
        commonClass.classList.remove('active');
        commonClass.classList.remove('change-text');
      }
    });

    genderTabs.forEach(t => t.classList.remove("active"));
    tab.classList.add("active");

    

    const target = tab.getAttribute("data-target");
    localStorage.setItem("selectedGender", target);

    console.warn("Saved gender in localStorage:", localStorage.getItem("selectedGender"));

    collections.forEach(col => {
      col.style.display = col.getAttribute("data-collection") === target ? "block" : "none";
    });

    // Hide all size options whenever a gender tab is clicked
    document.querySelectorAll(".find-your-fit__sizes .size-options").forEach(el => {
      el.style.display = "none";
    });

    const step1 = document.querySelector(".steps li:first-child");
    if (step1) {
      step1.classList.add("active");
    }

    // Only update currentBoxIndex if NOT triggered from modify button
    if (!isModifyTriggered) {
      const nextBoxIndex = selections.findIndex(sel => !sel.style || sel.styleName === null);
        currentBoxIndex = document.querySelector(".matching-undes-main.step-partner-wear") ? 1 : 0;
        imageBoxes[currentBoxIndex].setAttribute("data-target", target);
      // if (nextBoxIndex !== -1) {
      //   currentBoxIndex = nextBoxIndex;
      //   imageBoxes[currentBoxIndex].setAttribute("data-target", target);
      // } else {
      //   // If all boxes filled, allow overwriting the last one
      //   currentBoxIndex = selections.length - 1;
      //   imageBoxes[currentBoxIndex].setAttribute("data-target", target);
      // }
    } else {
      // Reset flag so future clicks update normally
      isModifyTriggered = false;
    }

    // Save gender selection in localStorage
    if (currentBoxIndex === 0) {
      localStorage.setItem("matching-undies-gender-for1", target);
    } else if (currentBoxIndex === 1) {
      localStorage.setItem("matching-undies-gender-forpartner", target);
    }
    // updateStepHeadings(index, "style", target);
  });
});




    // -------------------- Style Option --------------------
document.addEventListener("click", function (e) {
  if (e.target.closest(".style-option")) {
    const option = e.target.closest(".style-option");

    const step1index = document.querySelector(".steps li.commonclass:nth-child(1)");
    if (step1index && activeGenderIndex !== null) {
      step1index.setAttribute("li-index", activeGenderIndex);
      console.warn("Step 1 li-index set to:", activeGenderIndex);
    }

    const textData = document.querySelectorAll(".image-box-text-data");
    textData.forEach(el => {
      el.style.display = "none"; // hide all
    });

    const imgUrl = option.getAttribute("data-img");
    const name = option.getAttribute("data-name");
    console.warn(currentBoxIndex, "this is current")
    // setTimeout(function(){
    //   loadScriptOnce();
    //   console.warn("Size calculator loaded");
    // }, 1000);
    snfWidgetCode();
    // Always use currentBoxIndex
    const targetBox = imageBoxes[currentBoxIndex];
    if (!targetBox) return;

    const targetImg = targetBox.querySelector("img");
    const targetLabel = targetBox.querySelector(".style-label");

    if (targetImg) {
      targetImg.src = imgUrl || "";
      targetImg.alt = name || "Selected Style";
    }
    if (targetLabel) {
      targetLabel.textContent = name || "";
      // targetLabel.style.display = name ? "inline-block" : "none";
    }
    option.setAttribute("style-data-layout", "selected-style");
    // Also add attribute on the parent collection-items div
    const parentCollection = option.closest(".collection-items");
    if (parentCollection) {
      parentCollection.setAttribute("style-data-layout", "selected-style");
    }
    // Save style selection
    selections[currentBoxIndex].style = true;
    selections[currentBoxIndex].styleName = name;

    if (currentBoxIndex === 0) {
      localStorage.setItem("matching-undies-stylename-for1", name);
    } else if (currentBoxIndex === 1) {
      localStorage.setItem("matching-undies-stylename-forpartner", name);
    }

    updateStepHeadings(currentBoxIndex, "style", name); 

    // Show size options for the active gender
    const activeTab = document.querySelector(".gender-tab.active");
    const gender = activeTab ? activeTab.getAttribute("data-target") : null;

    document.querySelectorAll(".find-your-fit__sizes .size-options").forEach(el => {
      el.style.display = "none";
    });
    if (gender) {
      const sizeBox = document.querySelector(`.find-your-fit__sizes .size-options[data-collection="${gender}"]`);
      if (sizeBox) sizeBox.style.display = "flex";
    }
  }
});

// -------------------- Size Option --------------------
document.addEventListener("click", function (e) {
  if (e.target.closest(".size-option")) {
    const sizeBtn = e.target.closest(".size-option");
    let steps2 = document.querySelectorAll(".steps li");
    const size = sizeBtn.getAttribute("data-size");
    steps2[1].classList.add("change-text");
    

    const step2index = document.querySelector(".steps li.commonclass:nth-child(2)");
    if (step2index && activeGenderIndex !== null) {
      step2index.setAttribute("li-index", activeGenderIndex);
      console.warn("Step 2 li-index set to:", activeGenderIndex);
    }

        // ✅ Remove active from all gender-tabs when guide text is shown
        document.querySelectorAll(".gender-tab").forEach(tab => {
          tab.classList.remove("active");
        });
     
    // Always use currentBoxIndex
    const targetBox = imageBoxes[currentBoxIndex];
    if (!targetBox) return;

    // Hide style label when size chosen
    const targetLabel = targetBox.querySelector(".style-label");
    // if (targetLabel) targetLabel.style.display = "none";

    // Add/update size element
    let sizeEl = targetBox.querySelector(".selected-size");
    if (!sizeEl) {
      sizeEl = document.createElement("div");
      sizeEl.classList.add("selected-size");
      sizeEl.style.position = "absolute";
      sizeEl.style.top = 0;
      sizeEl.style.right = 0;
      sizeEl.style.border = "2px dashed #e63946";
      sizeEl.style.padding = "2px 6px";
      sizeEl.style.fontSize = "12px";
      sizeEl.style.fontWeight = "bold";
      sizeEl.style.borderRadius = "3px";
      sizeEl.style.borderTop = "none";
      sizeEl.style.borderRight = "none";
      sizeEl.style.color = "#e84d6d";
      sizeEl.style.background = "#fff";
      targetBox.appendChild(sizeEl);
    }
    sizeEl.textContent = size.toUpperCase();

    sizeBtn.setAttribute("size-data-layout", "selected-size");
    
    // Save size selection
    selections[currentBoxIndex].size = true;
    selections[currentBoxIndex].sizeValue = size;
    updateStepHeadings(currentBoxIndex, "size", size);

    if (currentBoxIndex === 0) {
      localStorage.setItem("matching-undies-size-for1", size);
    } else if (currentBoxIndex === 1) {
      localStorage.setItem("matching-undies-size-forpartner", size);
    }

    // ✅ Don’t auto-increment currentBoxIndex here.
    // User must click a gender tab again to fill the next box.
    checkCompletion();
  }
});


    // -------------------- Tab Swatch --------------------
    function setupTabSwatchClickHandlers() {
      const container = document.querySelector(".preview-variant-inner");
      if (!container) return;

      const swatches = container.querySelectorAll(".tab-swatch");
      const selectedLabel = document.querySelector(".type-label--selected");

      swatches.forEach(swatch => {
        swatch.addEventListener("click", function () {
          swatches.forEach(btn => btn.classList.remove("active"));
          this.classList.add("active");
          const targetBox = imageBoxes[currentBoxIndex];
            const targetLabel = targetBox.querySelector(".style-label");
            // if (targetLabel) targetLabel.style.display = "none";
          const designName = this.getAttribute("data-name");
          const productIds = this.getAttribute("data-product-ids").split(",");
          console.warn("Clicked swatch →", { designName, productIds });

          const style1 = localStorage.getItem("matching-undies-stylename-for1");
          const size1 = localStorage.getItem("matching-undies-size-for1");
          const style2 = localStorage.getItem("matching-undies-stylename-forpartner");
          const size2 = localStorage.getItem("matching-undies-size-forpartner");

          let variantIds = [];
          if (productIds[0] && style1 && size1) {
            const v1 = getVariantIdBySize(productIds[0], size1);
            if (v1) variantIds.push(v1);
          }
          if (productIds[1] && style2 && size2) {
            const v2 = getVariantIdBySize(productIds[1], size2);
            if (v2) variantIds.push(v2);
          }

          console.log("✅ Variant IDs for this swatch:", variantIds);
          const nextStemBtnMain = document.querySelector(".pointer-visible");
          if (nextStemBtnMain) {
            nextStemBtnMain.style.pointerEvents = "auto";
          }
          localStorage.setItem("designName", designName);
          if (selectedLabel) selectedLabel.textContent = designName;

          // Update preview images
          const imgContainer = document.querySelector(".preview-images");
          if (imgContainer) {
            imgContainer.innerHTML = "";
            productIds.forEach(id => {
              const imgUrl = getProductPreviewImage(id);
              if (imgUrl) {
                const img = document.createElement("img");
                img.src = imgUrl;
                img.alt = "Product Preview";
                img.style.maxWidth = "120px";
                img.style.marginRight = "8px";
                img.setAttribute("data-product-id", id);
                imgContainer.appendChild(img);
              }
            });
          }

          imageBoxes.forEach(box => {
            const boxImg = box.querySelector("img");
            if (boxImg) {
                boxImg.src = "https://via.placeholder.com/120x120?text=No+Image";
                boxImg.alt = "Product Preview";
            }
            });


          // Update main boxes
          for (let i = 0; i < imageBoxes.length; i++) {
            const box = imageBoxes[i];
            if (!box) continue;
            const boxImg = box.querySelector("img");
            const boxLabel = box.querySelector(".style-label");
            const sizeEl = box.querySelector(".selected-size");

            // Assign productId based on index if available
            const id = productIds[i] || productIds[0];
            const imgUrl = getProductPreviewImage(id);
            if (boxImg && imgUrl) boxImg.src = imgUrl;
            // if (boxLabel) boxLabel.textContent = designName;
            // if (sizeEl) sizeEl.style.display = "none";
            }
        });
      });

      // Restore last choice
      // const saved = localStorage.getItem("designName");
      // if (saved) {
      //   const match = Array.from(swatches).find(btn => btn.dataset.name === saved);
      //   if (match) match.click();
      // } else if (swatches.length > 0) {
      //   swatches[0].click();
      // }
    }

    // -------------------- Common Products --------------------
    function setCommonProducts() {
      const style1 = localStorage.getItem("matching-undies-stylename-for1");
      const style2 = localStorage.getItem("matching-undies-stylename-forpartner");
      const size1 = localStorage.getItem("matching-undies-size-for1");
      const size2 = localStorage.getItem("matching-undies-size-forpartner");

      if (!style1 || !style2 || !size1 || !size2) {
        console.warn("⚠️ Missing style/size selection for common products");
        return [];
      }

      const raw1 = localStorage.getItem(style1);
      const raw2 = localStorage.getItem(style2);
      if (!raw1 || !raw2) {
        console.warn("⚠️ Missing product arrays for styles:", style1, style2);
        return [];
      }

      let products1 = [], products2 = [];
      try { products1 = JSON.parse(raw1) || []; } catch (e) {}
      try { products2 = JSON.parse(raw2) || []; } catch (e) {}

      const valid1 = products1.filter(p => {
        return Object.values(p.variants || {}).some(v =>
          v.title.toLowerCase() === size1.toLowerCase() && v.inventory_quantity > 0
        );
      });

      const valid2 = products2.filter(p => {
        return Object.values(p.variants || {}).some(v =>
          v.title.toLowerCase() === size2.toLowerCase() && v.inventory_quantity > 0
        );
      });

      const result = [];
      valid1.forEach(p1 => {
        const match = valid2.find(p2 => p2.design_name === p1.design_name);
        if (match) {
          if (!result.some(r => r.product_id === p1.product_id)) result.push(p1);
          if (!result.some(r => r.product_id === match.product_id)) result.push(match);
        }
      });

      localStorage.setItem("commonProductsformatching", JSON.stringify(result));
      console.log("✅ Common products for matching:", result);

      return result;
    }

    // -------------------- Variant Finder --------------------
    function getVariantIdBySize(productId, selectedSize) {
      const commonProducts = JSON.parse(localStorage.getItem("commonProductsformatching") || "[]");
      const product = commonProducts.find(p => String(p.product_id) === String(productId));
      if (!product) {
        console.warn("⚠️ Product not found for ID:", productId);
        return null;
      }

      for (const variantId in product.variants) {
        const v = product.variants[variantId];
        if (v.title.toLowerCase() === selectedSize.toLowerCase()) {
          return variantId;
        }
      }

      console.warn("⚠️ Variant not found for size:", selectedSize, "in product", productId);
      alert("Selected size is not available for this product.");
      return null;
    }

  // -------------------- Variant Finder --------------------
    function getInventoryQuantity(productId, variantId) {
        const product = commonProductsData.find(p => String(p.product_id) === String(productId));
        if (!product) {
            console.warn("❌ Product not found:", productId);
            return null;
        }

        const variant = product.variants[variantId];
        if (!variant) {
            console.warn("❌ Variant not found:", variantId, "for product", productId);
            return null;
        }

  return variant.inventory_quantity;
}


    // -------------------- Preview Image Helper --------------------
    function getProductPreviewImage(productId) {
      productId = Number(productId);

      if (window.allProductsData[productId] && window.allProductsData[productId].custom_tool_preview_image) {
        return window.allProductsData[productId].custom_tool_preview_image;
      }

      const found = commonProductsData.find(p => p.product_id === productId);
      if (found && found.custom_tool_preview_image) {
        return found.custom_tool_preview_image;
      }

      console.error("❌ Product preview image not available for product ID:", productId);
      return "https://via.placeholder.com/120x120?text=No+Image";
    }

  // -------------------- Seal Button & Modify --------------------
const sealBtn = document.querySelector(".seal-btn");
const contentDiv = document.querySelector(".matching-undies__content");
const successDiv = document.querySelector(".matching-undies__success");
const modifyButtons = document.querySelectorAll(".modify-btn");

modifyButtons.forEach(btn => btn.style.display = "none");

  if (sealBtn) {
    sealBtn.addEventListener("click", async function () {
      // ✅ Only run add-to-cart when seal-btn has red-active
      if (!sealBtn.classList.contains("red-active")) {
        // First click → show success and mark red-active
        if (contentDiv) contentDiv.style.display = "none";
        if (successDiv) successDiv.style.display = "flex";
        sealBtn.classList.add("red-active");

        modifyButtons.forEach(btn => btn.style.display = "block");
        return; // stop here, no add-to-cart yet
      }

      // ✅ If button is already red-active → add to cart
      const activeSwatch = document.querySelector(".tab-swatch.active");
      if (!activeSwatch) {
        alert("Please complete all steps before sealing the match.");
        return;
      }

      const productIds = activeSwatch.getAttribute("data-product-ids").split(",");
      const style1 = localStorage.getItem("matching-undies-stylename-for1");
      const size1 = localStorage.getItem("matching-undies-size-for1");
      const style2 = localStorage.getItem("matching-undies-stylename-forpartner");
      const size2 = localStorage.getItem("matching-undies-size-forpartner");
      const gender1 = localStorage.getItem("matching-undies-gender-for1");
      const gender2 = localStorage.getItem("matching-undies-gender-forpartner");

      console.warn(
        "Product Id = ", productIds,
        "style1 = ", style1,
        "size1 = ", size1,
        "gender1 = ", gender1,
        "style2 = ", style2,
        "size2 = ", size2,
        "gender2 = ", gender2
      );
      let variantItems = [];
    console.warn(
          "Product 0 = ", productIds[0],
          "productIds[1] = ", productIds[1],
          "style1 = ", style1,
          "style2 =" , style2,
          "gender1 = ",gender1,
          "size1 = ", size1,
          "size2 = ", size2,
          "gender2 = ", gender2
        );
      if (
        style1 === style2 &&
        size1 === size2 &&
        gender1 === gender2 &&
        (
          productIds.length === 1 || // case: only 1 productId exists
          (productIds.length > 1 && productIds[0] === productIds[1]) // case: 2 but same
        )
      ) {
        const v = getVariantIdBySize(productIds[0], size1);
        console.warn("🟢 SAME variant detected, qty 2 →", v);
        if (v) {
          variantItems.push({
            id: v,
            quantity: 2,
            properties: {
              comboType: "Matching Undie"
            }
          });
        }
      } else {
        // Normal case: add each separately
        if (productIds[0] && style1 && size1) {
          const v1 = getVariantIdBySize(productIds[0], size1);
          if (v1) {
            variantItems.push({
              id: v1,
              quantity: 1,
              properties: {
                comboType: "Matching Undie"
              }
            });
          }
        }

        if (productIds[1] && style2 && size2) {
          const v2 = getVariantIdBySize(productIds[1], size2);
          if (v2) {
            variantItems.push({
              id: v2,
              quantity: 1,
              properties: {
                comboType: "Matching Undie"
              }
            });
          }
        }
      }

        if (variantItems.length === 0) {
          alert("No valid variants found for your selection.");
          return;
        }

        console.log("🛒 Adding these variants to cart with properties:", variantItems);

        try {
          await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: variantItems }),
          })
            .then(res => res.json())
            .then(response => {
              console.log("✅ Added to cart:", response);
              if (window.MinimogSettings && window.MinimogSettings.use_ajax_atc) {
                window.REFRESH_CART();
                setTimeout(() => {
                  window.OPEN_CART();
                }, 800);
              }
            });
        } catch (err) {
          console.error("Add to cart error:", err);
        }
      });
    }

  modifyButtons.forEach((btn, index) => {
    btn.addEventListener("click", function () {

      // Hide success message, show steps again
      if (successDiv) successDiv.style.display = "none";
      if (contentDiv) contentDiv.style.display = "block";
      sealBtn.classList.remove("red-active");

      // Hide all modify buttons until SEAL again
      modifyButtons.forEach(b => b.style.display = "none");
      currentBoxIndex = index;
      isModifyTriggered = true;
      currentBoxIndex === 0 ? setStepParam("i-wear") : setStepParam("partner-wear");
      // ----- NEW PART -----
      // Find selected gender from the image-box
      const imageBox = document.querySelectorAll(".matching-undies__images .image-box")[index];
      const selectedGender = imageBox ? imageBox.getAttribute("data-target") : null;

      if (selectedGender) {
        const targetTab = document.querySelector(`.gender-tab[data-target="${selectedGender}"]`);
        if (targetTab) {
          targetTab.click(); // Open that gender’s Step 1

          // Show size options for selected gender
          const sizeBox = document.querySelector(`.find-your-fit__sizes .size-options[data-collection="${selectedGender}"]`);
          if (sizeBox) sizeBox.style.display = "flex";
        }
      }
    
      const customcommonclassmu = document.querySelectorAll(".commonclass");
      if(customcommonclassmu){
        customcommonclassmu.forEach((custombtnmu, index) => {
          if(!custombtnmu.classList.contains('active')){
            custombtnmu.classList.add('active');
          }
        })
      }
    });
  });

  document.querySelectorAll(".collection-items").forEach(item => {
    item.addEventListener("click", () => {
      const steps = document.querySelectorAll(".steps li");
      if (steps.length >= 2) {
        // Step 1 → add change-text
        steps[0].classList.add("change-text");
        // Step 2 → add active
        steps[1].classList.add("active");
      }
    });
  });


  function updateStepHeadings(pairIndex, type, value) {
    if (type === "style") {
      pairStyleTexts[pairIndex] = value || "";
    }
    if (type === "size") {
      pairSizeTexts[pairIndex] = value ? value.toUpperCase() : "";
    }

    const step1 = document.querySelector(".steps li.commonclass:first-child strong");
    const step2 = document.querySelectorAll(".steps li.commonclass")[1].querySelector("strong");

    if (step1) {
      const styleToShow = pairStyleTexts[pairIndex] || "";
      step1.textContent = styleToShow
        ? `1. ${styleToShow}`
        : "1. Pick Your Style";
    }

    if (step2) {
      const sizeToShow = pairSizeTexts[pairIndex] || "";
      step2.textContent = sizeToShow
        ? `2. ${sizeToShow}`
        : "2. Select Your Size";
    }
  }

  function resetStepHeadings(pairIndex) {
    pairStyleTexts[pairIndex] = "";
    pairSizeTexts[pairIndex] = "";

    const step1 = document.querySelector(".steps li.commonclass:first-child strong");
    const step2 = document.querySelectorAll(".steps li.commonclass")[1].querySelector("strong");

    if (step1) step1.textContent = "1. Pick Your Style";
    if (step2) step2.textContent = "2. Select Your Size";
  }

  function snfWidgetCode() {
    let productCode;
    let url = window.location.href;
    let pagestep = false;

    // ✅ Get gender directly from localStorage instead of params
    const selectedGender = localStorage.getItem("selectedGender");

    setTimeout(function () {
      // Clean up duplicate #matchmen
      let divs = document.querySelectorAll("#matchmen");
      if (divs.length > 1) {
        divs.forEach((div, index) => {
          const attributes = Array.from(div.attributes);
          let foundId = false;

          attributes.forEach(attr => {
            if (attr.name === "id") {
              foundId = true;
            } else if (foundId) {
              if (attr.name === "style") {
                const styleProperties = div.style;
                if (styleProperties.display) {
                  div.style.display = ""; 
                }
              } else {
                div.removeAttribute(attr.name);
              }
            }
          });

          div.classList.remove("ng-animate-disabled");
          div.innerHTML = "";
        });
      }

      // Clean up duplicate #matchwomen
      let divsw = document.querySelectorAll("#matchwomen");
      if (divsw.length > 1) {
        divsw.forEach((div, index) => {
          const attributes = Array.from(div.attributes);
          let foundId = false;
          attributes.forEach(attr => {
            if (attr.name === "id") {
              foundId = true;
            } else if (foundId) {
              if (attr.name === "style") {
                const styleProperties = div.style;
                if (styleProperties.display) {
                  div.style.display = ""; 
                }
              } else {
                div.removeAttribute(attr.name);
              }
            }
          });

          div.classList.remove("ng-animate-disabled");
          div.innerHTML = "";
        });
      }
    }, 500);
    if (url.includes("?step=partner-wear") && !url.includes("return_url=")) {
      pagestep = document.querySelector(".step-partner-wear");
    } else if (url.includes("?step=i-wear") && !url.includes("return_url=")) {
      pagestep = document.querySelector(".step-i-wear");
    }

    setTimeout(function () {
      if (pagestep != false) {
        if (selectedGender === "men") { 
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).removeAttribute("fmf-widget-manager");
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).style.display = "none";
          
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).setAttribute("fmf-widget-manager", "");   
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).style.display = "block";  
          productCode = "TC-Men-Underwear";
        }
        if (selectedGender === "women") {
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).removeAttribute("fmf-widget-manager");
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).style.display = "none";
          
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).setAttribute("fmf-widget-manager", "");   
          pagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).style.display = "block";
          productCode = "TC-Women-Underwear";
        }
            
        if (productCode) {
          let productDiv = pagestep.querySelector(`.size-options[data-collection="${selectedGender}"]`).querySelector("[fmf-widget-manager]");
          if (productDiv) {
            productDiv.setAttribute("product-code", productCode);
          }
        }
      } else {
        let newpagestep = "";
        if (url.includes("?step=i-wear") && url.includes("return_url=")) {
          newpagestep = document.querySelector(".step-i-wear");

          if (selectedGender === "men") { 
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).removeAttribute("fmf-widget-manager");
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).setAttribute("fmf-widget-manager", "");   
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).style.display = "block";  
            productCode = "TC-Men-Underwear";
          }
          if (selectedGender === "women") {
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).removeAttribute("fmf-widget-manager");
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).setAttribute("fmf-widget-manager", "");   
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).style.display = "block";
            productCode = "TC-Women-Underwear";
          }
                
          if (productCode) {
            let productDiv = newpagestep.querySelector("[fmf-widget-manager]");
            if (productDiv) {
              productDiv.setAttribute("product-code", productCode);
            }
          }
        } else if (url.includes("?step=partner-wear") && url.includes("return_url=")) {
          newpagestep = document.querySelector(".step-partner-wear");

          if (selectedGender === "men") { 
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).removeAttribute("fmf-widget-manager");
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).setAttribute("fmf-widget-manager", "");   
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).style.display = "block";  
            productCode = "TC-Men-Underwear";
          }
          if (selectedGender === "women") {
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchmen`).removeAttribute("fmf-widget-manager");
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).setAttribute("fmf-widget-manager", "");   
            newpagestep.querySelector(`.size-options[data-collection="${selectedGender}"] #matchwomen`).style.display = "block";
            productCode = "TC-Women-Underwear";
          }
              
          if (productCode) {
            let productDiv = newpagestep.querySelector("[fmf-widget-manager]");
            if (productDiv) {
              productDiv.setAttribute("product-code", productCode);
            }
          }
        }
      }
      loadScriptOnce();
    }, 550);
  }

  function loadScriptOnce() {
    let scripts = [
      "https://d1pwxj66mjl9h0.cloudfront.net/angular/runtime.js",
      "https://d1pwxj66mjl9h0.cloudfront.net/angular/polyfills.js",
      "https://d1pwxj66mjl9h0.cloudfront.net/angular/scripts.js",
      "https://d1pwxj66mjl9h0.cloudfront.net/angular/main.js"
    ];

    scripts.forEach(function(src) {
      // Remove old script if it exists
      let existingScript = document.querySelector(`script[src="${src}"]`);
      if (existingScript) {
        existingScript.parentNode.removeChild(existingScript);
      }

      // Add new script
      let script = document.createElement('script');
      script.src = src;
      script.async = true; // Load script asynchronously
      document.body.appendChild(script);
    });
  }


  setTimeout(function() {
    loadScriptOnce();
  }, 200);
});

document.addEventListener("DOMContentLoaded", function () {
  // when parent div is clicked
  document.querySelectorAll(".size-chart-pop .popup-btn").forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      let overlay = this.closest(".size-chart-pop").querySelector(".popup-overlay");
      let popup = this.closest(".size-chart-pop").querySelector(".popup");
      overlay.style.display = "block";
      popup.style.display = "block";
    });
  });

  // close button
  document.querySelectorAll(".popup-close").forEach(btn => {
    btn.addEventListener("click", function () {
      this.closest(".popup-overlay").style.display = "none";
      this.closest(".popup").style.display = "none";
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const group = document.querySelector('.button-group');
  if (!group) return;

  const popsSelector = '.size-chart-pop';

  function showForTarget(target) {
    document.querySelectorAll(popsSelector).forEach(p => {
      p.classList.toggle('hidden', p.getAttribute('data-open') !== target);
    });
  }

  function handleButton(btn) {
    if (!btn) return;
    const target = btn.dataset && btn.dataset.target;
    if (target) showForTarget(target);
  }

  // initial state: prefer an element with .active, otherwise first button
  const initial = group.querySelector('.gender-tab.active') || group.querySelector('.gender-tab');
  if (initial) handleButton(initial);

  // Delegation: works even if buttons are replaced or added later
  group.addEventListener('click', (e) => {
    const btn = e.target.closest('.gender-tab');
    if (!btn || !group.contains(btn)) return;
    handleButton(btn);
  });

  // MutationObserver: catches when some other script adds/removes "active"
  const obs = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        const el = m.target;
        if (el.classList && el.classList.contains('gender-tab') && el.classList.contains('active')) {
          handleButton(el);
        }
      }
      if (m.type === 'childList') {
        // if new buttons are added with .active, handle them
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.gender-tab') && node.classList.contains('active')) {
            handleButton(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.gender-tab.active').forEach(n => handleButton(n));
          }
        });
      }
    }
  });

  obs.observe(group, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector(".match-header.seal-btn");
  const button = document.querySelector(".match-header__button.seal-the-match-btn .seal-btn");

  function updateButtonStyle() {
    if (target && button) {
      const pointerEvents = target.style.pointerEvents;
      if (pointerEvents === "auto") {
        button.style.background = "#000";
        button.style.color = "#fff";
      } else {
        button.style.background = "";
        button.style.color = "";
      }
    }
  }

  // Run initially
  updateButtonStyle();

  // Observe style changes dynamically
  const observer = new MutationObserver(updateButtonStyle);
  if (target) {
    observer.observe(target, { attributes: true, attributeFilter: ["style"] });
  }
});

(() => {
  // utility: consider "null", empty, or "undefined" as invalid
  const isNullName = name => !name || name.trim() === "" || name === "null" || name === "undefined";

  // hide parent .type_swatch.all when its .tab-swatch has a null/invalid data-name
  function hideNullSwatches(root = document) {
    root.querySelectorAll('.type_swatch.all .tab-swatch').forEach(btn => {
      const name = btn.getAttribute('data-name');
      if (isNullName(name)) {
        const parent = btn.closest('.type_swatch.all');
        if (parent) parent.style.display = 'none'; // or parent.remove() to remove from DOM
      }
    });
  }

  // initial pass (in case some are already present)
  hideNullSwatches();

  // Observe dynamic insertions anywhere under body
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (!m.addedNodes.length) continue;
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return; // skip non-elements
        // Check the added node and its subtree for target buttons
        hideNullSwatches(node);
      });
    }
  });

  // If you know a more specific container to watch, replace document.body with that element for better perf:
  // const watchRoot = document.querySelector('.product-form') || document.body;
  const watchRoot = document.body;
  observer.observe(watchRoot, { childList: true, subtree: true });

  // optional: stop observing after X seconds if you only expect a short period of dynamic loading
  // setTimeout(() => observer.disconnect(), 30_000);

})();

